enum Errors {
  NETWORK_ERROR = 'Ups, revisa tu conexión de internet',
  UNAUTHORIZED = 'No tiene autorización para realizar ingresar.',
  INVALID_GRANT = 'Usuario o contraseña incorrecta. Intenta nuevamente o recupera contraseña.',
}

export default Errors
